import { memo } from 'react';
import { useInfiniteEmployeeListQuery, useInfiniteManagerListQuery } from '@/queries/employee';
import { EmployeeRole } from '@/api/apis/resources';
import { ManagerDropdown } from './ManagerDropdown';

type HubManagersProps = {
  isReadOnly?: boolean;
};

export const HubManagers = memo(({ isReadOnly }: HubManagersProps) => {
  return (
    <>
      <ManagerDropdown
        title="Regional Manager"
        idFieldName="regionalManagerId"
        nameFieldName="regionalManagerName"
        listQuery={useInfiniteEmployeeListQuery}
        role={EmployeeRole.RegionalCSManagement}
        isReadOnly={isReadOnly}
      />
      <ManagerDropdown
        title="National Manager"
        idFieldName="nationalManagerId"
        nameFieldName="nationalManagerName"
        listQuery={useInfiniteManagerListQuery}
        role={EmployeeRole.NationalCSManagement}
        isReadOnly={isReadOnly}
      />
    </>
  );
});
